import { Component, OnInit, Injector, NgZone } from '@angular/core';
import { PoPageLogin, PoPageLoginLiterals } from '@po-ui/ng-templates';
import { PoToasterOrientation, PoNotification } from '@po-ui/ng-components';
import { Login } from './login';
import { PageBase } from '../../shared/library/page.base';
import { RMSContext } from './../../shared/models/usercontext.model';
import { ProjectServices } from 'src/app/Context/contextservices/project.service';
import { PoLanguage } from '@po-ui/ng-components/lib/services/po-language/po-language.interface';
import { ContextCockpit } from 'src/utils/enums';
import { AuthenticationService } from 'src/service/authentication.service';

@Component({
    selector: 'cp-login',
    templateUrl: './login.component.html',
    standalone: false
})

export class LoginComponent extends PageBase implements OnInit {
  login: string;
  event: string;
  loginUser: Login;
  contextUser: RMSContext = null;
  loadingLogin: boolean = false;
  customLiteralsLogin: PoPageLoginLiterals = {}

  languages: Array<PoLanguage> = [];

  /**
   * Creates an instance of LoginComponent.
   * @param {Injector} objInjector Injector
   * @memberof LoginComponent
   */
  constructor(
    public objInjector: Injector,
    public ngZone: NgZone,
    public serviceProjeto: ProjectServices,
    private authenticationService: AuthenticationService
  ) {
    super(objInjector);
  }

  ngOnInit(): void {
    this.loginValidate();
    this.restore();
    super.ngOnInit();
    this.poI18nService
      .getLiterals({ language: this.poI18nService.getLanguage(), context: 'customLogin' })
      .subscribe(ctLiteralsLogin => {
        this.customLiteralsLogin = ctLiteralsLogin;
        this.onReceiveLiterals();
      });

    this.SetPoLanguage();
  }

  /**
   * Verifica se o usuário está autenticado
   */

  isUserAuthenticated(): boolean {

    if (this.checkTokenBearer())
      return true;
    else if (this.checkTokenSaml())
      return true;
    else if (this.checkERPToken())
      return true;
    else return false;
  }

  /**
   * Verifica a validade do token ERP e configura o contexto da aplicação.
   * 
   * @returns `true` se o token ERP for válido, caso contrário `false`.
   */
  checkERPToken(): boolean {
    let tokenERP = sessionStorage.getItem('ERPTOKEN');
    if (!tokenERP) {
      return false;
    }
    try {
      this.contextApplication.ContextCockpit = ContextCockpit.RM;
      this.contextApplication.Token = JSON.parse(tokenERP);

      const contexto = JSON.parse(sessionStorage.getItem('INFOPROJECT'));

      if (!contexto) {
        return false;
      }

      this.contextApplication.Usuario.username = contexto['userName'];
      this.contextApplication.Usuario.password = contexto['userName'];

      console.log('language INFOPROJECT:', contexto['language']);

      this.contextApplication.language = contexto['language'];
      this.contextApplication.Project.companyId = Number(contexto['codColigada']);
      this.contextApplication.Project.projectId = Number(contexto['IdPrj']);
      this.contextApplication.Project.description = contexto['descProject'];
      this.contextApplication.Project.projectCode = contexto['codProject'];
      this.contextApplication.Project.review = contexto['reviewProject'];
      this.contextApplication.Project.lastCalculation = contexto['lastCalculate'];
      this.contextApplication.Project.lastBackofficeImport = contexto['lastBackofficeImport'];

      this.router.navigate(['cockpittop']);
      return true;

    } catch (error) {
      console.error('Erro ao decodificar o ERPTOKEN:', error);
      return false;
    }
  }

  /**
   * Verifica a validade do token SAML e configura o contexto da aplicação.
   * 
   * @returns `true` se o token ERP for válido, caso contrário `false`.
   */
  checkTokenSaml(): boolean {
    let tokenSaml = JSON.parse(sessionStorage.getItem('tokenSaml'));

    if (tokenSaml == null) {
      return false;
    }

    try {
      this.contextApplication.Token = tokenSaml;
      return this.loginOkPortalDaObra();

    } catch (error) {
      console.error('Erro ao decodificar o tokenSaml:', error);
      return false;
    }
  }

  /**
   * Verifica a validade do token SAML e configura o contexto da aplicação.
   * 
   * @returns `true` se o token ERP for válido, caso contrário `false`.
   */
  checkTokenBearer(): boolean {
    let tokenBearer = sessionStorage.getItem('tokenBearer');

    if (!tokenBearer) {
      return false;
    }

    try {
      this.contextApplication.Token = JSON.parse(tokenBearer);

      return this.loginOkPortalDaObra();

    } catch (error) {
      console.error('Erro ao decodificar o tokenBearer:', error);
      return false;
    }
  }

  loginOkPortalDaObra(): boolean {
    this.contextApplication.ContextCockpit = ContextCockpit.PortalDaObra;

    const contextoUsuario = JSON.parse(sessionStorage.getItem('contextoUsuario'));

    if (!contextoUsuario) {
      return false;
    }

    this.contextApplication.Usuario.username = contextoUsuario['usuario']['userCode'];
    this.contextApplication.Usuario.password = contextoUsuario['usuario']['userCode'];

    // Projeto
    this.contextApplication.Project.companyId = Number(contextoUsuario['projeto']['companyId']);
    this.contextApplication.Project.projectId = Number(contextoUsuario['projeto']['projectId']);
    this.contextApplication.Project.description = contextoUsuario['projeto']['description'];
    this.contextApplication.Project.projectCode = contextoUsuario['projeto']['projectCode'];
    this.contextApplication.Project.review = contextoUsuario['projeto']['review'];
    this.contextApplication.Project.lastCalculation = this.setDates(contextoUsuario['projeto']['lastCalculation']);
    this.contextApplication.Project.lastBackofficeImport = this.setDates(contextoUsuario['projeto']['lastBackofficeImport']);
    this.setLanguage();
    this.router.navigate(['cockpittop']);
    return true;
  }

  loginValidate() {
    // Verifica se o usuário está logado para acessar a página
    if (this.isUserAuthenticated()) {
      console.log('Usuário autenticado');
    }
    else {
      console.log('Usuário NÃO autenticado');
    }
  }

  onReceiveLiterals(): void {

  }

  changeLanguage(planguageCh: PoLanguage): void {
    this.languageCh = planguageCh;

    console.log(this.languageCh.language);
    this.poI18nService.setLanguage(this.languageCh.language);

    this.poI18nService
      .getLiterals({ language: this.languageCh.language, context: 'customLogin' })
      .subscribe(ctLiteralsLogin => {
        this.customLiteralsLogin = ctLiteralsLogin;
        this.onReceiveLiterals();
      });

    this.poI18nService.getLiterals({ language: this.languageCh.language }).subscribe(objLiterals => {
      this.literalsCp = objLiterals;
    });

  }

  SetPoLanguage() {
    this.languages = [
      { language: 'pt', description: this.literalsCp?.strPortugues },
      { language: 'es', description: this.literalsCp?.strEspanhol },
      { language: 'en', description: this.literalsCp?.strIngles }];
  }

  changeEvent(event: string) {
    this.event = event;
  }

  restore() {
    this.event = '';
    this.login = '';
  }

  loginSubmit(formData: PoPageLogin) {
    this.loadingLogin = true;
    this.loginService.login(formData.login, formData.password).subscribe(
      async () => {
        this.contextApplication.Usuario.username = formData.login;
        this.contextApplication.Usuario.password = formData.password;
        console.log('Login efetuado com sucesso');
        await this.authenticationService
          .GetAccessToken(this.contextApplication.Usuario.username,
            this.contextApplication.Usuario.password,
            this.contextApplication.Server.apiServer).finally(() => {
              this.loadingLogin = false;
              this.router.navigate(['cockpittop']);
            });


      },
      err => {
        const poNotification: PoNotification = {
          message: err.message,
          orientation: PoToasterOrientation.Top,
          duration: 5000
        };
        this.poNotification.error(poNotification);
        this.loadingLogin = false;
      });
  }

  setLanguage(): void {
    const languageBrowser = navigator.language;

    if (languageBrowser.toLowerCase().includes('es')) {
      const language: PoLanguage = { language: 'es' };
      this.changeLanguage(language);
    }
    else if (languageBrowser.toLowerCase().includes('en')) {
      const language: PoLanguage = { language: 'en' };
      this.changeLanguage(language);
    }
    else {
      const language: PoLanguage = { language: 'pt' };
      this.changeLanguage(language);
    }
  }

  setDates(date: string): Date {
    if (new Date(date).toString() !== 'Invalid Date') {
      return new Date(date);
    }
    else {
      return null;
    }
  }
}


